import React, {type ReactNode, useMemo, useState} from "react";
import {User} from "@/data/entities/user";
import {AuthContext} from "./use-auth";
import {getDashboardRole} from "@/data/entities/user/utils";


type Props = {
    user: User,
    children: ReactNode,
};

const AuthProvider = ({user: preLoadedUser, children}: Props) => {
    const [user, setUser] = useState<User>(preLoadedUser);
    const mainRole = useMemo(() => getDashboardRole(user), [user]);

    return (
        <AuthContext.Provider
            value={{
                user,
                setUser,
                mainRole,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;